<template>
    <!-- site -->
    <div class="site">
        <the-header></the-header>
        <div class="site__body">
            <!-- <div id="nav">
                <router-link to="/">Home</router-link> |
                <router-link to="/about">About</router-link>
                </div> -->
            <router-view/>
            <!-- <router-view v-slot="slotProps"> -->
            <!-- <transition name="fade-button" mode="out-in">
                <component :is="slotProps.Component"></component>
                </transition> -->
            <!-- </router-view> -->
            <div id="quickview-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true"></div>
            <the-footer></the-footer>
        </div>
    </div>
</template>

<script>
import TheHeader from './components/layout/TheHeader.vue';
import TheFooter from './components/layout/TheFooter.vue';
import MixinCustomer from './mixins/customer.js';
import axiosvl from "./axios/axios-vl.js";
import * as GCONST from './constants.js';
import CloudinaryApi from './utilities/cloudinaryapi.js';

export default {
    components: {
        TheHeader,
        TheFooter
    },
    mixins: [
        MixinCustomer
    ],
    data() {
        return {
            custdetails: {}
        }
    },
    // add comment
    methods: {
        async initialize() {
            await axiosvl.post(this.$store.getters['api/init_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "HOSTURL": {"value": this.$store.getters.hosturl},
                    }
                }
            })
            .then((response) => {

                const fields = response.data.webroutine.fields;
                const lists = response.data.webroutine.lists;
                const isLoggedIn = this.$store.getters.userIsAuthenticated;
                const LS_ATTR_FILTERS = lists.LS_ATTR_FILTERS.entries;
                const languages = [];
                const cust_attr = [];
                const filter_attr = [];
                const session_validity = this.$store.getters.session_validity;
                const now = new Date();
                console.log(session_validity);
                // compare the expiry time of the item with the current time
				if (session_validity != '' && now.getTime() > session_validity) {
					// If the item is expired, delete the item from storage
					console.log('expired session clear all the local storage');
                    this.$store.dispatch("cart/emptyCart");
                    this.$store.dispatch("cart/emptyKits");
                    this.$store.dispatch("vehicle/clearSelectedVehicle");
                    this.$store.dispatch("setUserAttributes", []);
                    this.$store.dispatch("resetCustomerDetails");
                    this.$store.dispatch('setSolr_faceted_filter', {});
                    this.$store.dispatch('logout');
				}

                //  48 hours validity
                // const ttl = 172800000;
                //  default 1 hr / 60mins validity
                const sess_in_mins = (fields.LW3SESSTO == undefined || fields.LW3SESSTO.value == 0) ? 60 : fields.LW3SESSTO.value;
                // convert it to milliseconds
                const ttl = sess_in_mins * 60 * 1000;
                console.log('Timeout in ms = ' + ttl);
                this.$store.dispatch('setSessionValidity', now.getTime() + ttl);
                
                if (fields.LW3WEBC01 != undefined) {
                    if (fields.LW3WEBC01.value != '') {
                        this.$store.dispatch('setDefaultB2CCustomer', fields.LW3WEBC01.value);
                    }
                }

                // desktop logo 
                if (fields.LW3SFDLOG != undefined) {
                    this.$store.dispatch('setDesktop_logo', fields.LW3SFDLOG.value);
                }

                // mobile logo
                if (fields.LW3SFMLOG != undefined) {
                    this.$store.dispatch('setMobile_logo', fields.LW3SFMLOG.value);
                }

                if(fields.LW3SFSRVR.value == 'N'){
                    window.location.href =  process.env.BASE_URL + 'downtime.html';
                }

                if (fields.LW3DKOE != undefined) {
                    if (fields.LW3DKOE.value != '') {
                        this.$store.dispatch('cart/setCEDKOE', fields.LW3DKOE.value);
                    }
                }

                // set revolutionary slider
                if (fields.LW3SLDURL != undefined) {
                    if (fields.LW3SLDURL.value != '') {
                        this.$store.dispatch('setSlider_url', fields.LW3SLDURL.value);
                    }
                }

                // set Store catalog
                if (fields.LW3SFTYPE != undefined) {
                    if (fields.LW3SFTYPE.value != '') {
                        this.$store.dispatch('setStoreCatalog', fields.LW3SFTYPE.value);
                    }
                }

                // set Storefront ID
                if (fields.LW3SFID != undefined) {
                    if (fields.LW3SFID.value != '') {
                        this.$store.dispatch('setStorefront', fields.LW3SFID.value);
                    }
                }

                if (this.$store.getters.customer === '' || this.$store.getters.customer === undefined) {
                    this.$store.dispatch('setCustomer', this.$store.getters.defaultB2Ccustomer);
                }

                if (fields.SOLR_HOST != undefined) {
                    if (fields.SOLR_HOST.value != '') {
                        this.$store.dispatch('setSolr_hostname', fields.SOLR_HOST.value);
                    }
                }

                if (fields.LW3SOLRIN != undefined) {
                    if (fields.LW3SOLRIN.value != '') {
                        this.$store.dispatch('setSolr_coreadmin', fields.LW3SOLRIN.value);
                    }
                }

                this.mx_getCustomerInformation();

                let storefrontattributes = [];

                for (const key in response.data.webroutine.lists.LS_SFATTRIBUTES.entries) {
                    const obj = response.data.webroutine.lists.LS_SFATTRIBUTES.entries[key];
                    storefrontattributes.push({
                        indicator: obj.LW3B2BIND,
                        id: obj.LW3SATID,
                        type: obj.LW3SATTY,
                        sequence: obj.LW3SATSQ,
                        desc: obj.LW3SATDS,
                        language: obj.LW3LNGCOD,
                        value: obj.LW3SATVL,
                        displaySequence: obj.LW3SADSQ,
                    });
                }

                /**
                 * set languages state
                 */
                for (const key in response.data.webroutine.lists.LS_LANGUAGES.entries) {
                    const obj_lang = response.data.webroutine.lists.LS_LANGUAGES.entries[key];
                    languages.push({
                        'lang_code'     : obj_lang.LW3LNGID,
                        'description'   : obj_lang.LW3LNGDSC,
                        'seq'           : obj_lang.LW3LNGSEQ,
                        'code'          : obj_lang.LW3LNGTCD,
                    });
                }
                this.$store.dispatch("setLanguages", languages);

                this.$store.dispatch("setStorefrontAttributes", storefrontattributes);

                if (!isLoggedIn){
                    this.$store.dispatch("cart/update_tax_rate", {tax_rate : 0});
                    this.$store.dispatch("cart/calculateTotals");
                }

                const cart_expiration = new Date(this.$store.getters['cart/cart_expiration']);
                const thistime = new Date();
                if (thistime > cart_expiration) {
                    // console.log('cart already expired, clearing the cart...');
                    // this.$store.dispatch("cart/emptyCart");
                }

                // set custom attributes
                for (const k in lists.LS_CUSTOMATTR.entries){
                    const attr = lists.LS_CUSTOMATTR.entries[k];
                    cust_attr.push(attr.LW3IATNM);
                }
                this.$store.dispatch("product/setCustom_attr", cust_attr);

                for(const a in LS_ATTR_FILTERS) {
                    filter_attr.push(LS_ATTR_FILTERS[a].LW3SLRFLD);
                }
                this.$store.dispatch("product/setFilter_attr", filter_attr);
                
                if (fields.LW3CATPN != undefined) {
                    if (fields.LW3SFID.value != '') {
                        this.catalogs(fields.LW3CATPN.value);
                    }
                }

                this.mfg_images();

                this.main_cat_images();

                this.fetchRMAEnabled();

                this.resetValues();
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

        mfg_images() {
            axiosvl.post(this.$store.getters['api/cl_mware_mfg_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "LW3SFID": {"value": this.$store.getters.storefront},
                        "META_VALUE": {"value": "metadata.resourcetype:" + GCONST.CL_METARTYPE_MFG}
                    }
                }
            })
            .then((response) => {
                const MANUFACTURERS_IMGS = response.data.webroutine.lists.MANUFACTURERS_IMGS;
                const mfgs_only = [];
                for (const key in MANUFACTURERS_IMGS.entries) {
                    const obj = MANUFACTURERS_IMGS.entries[key];
                    mfgs_only.push({
                        CL_PUBID: obj.CL_PUBID,
                        CL_RESURL: obj.CL_RESURL,
                        CL_MFGCODE: obj.CL_MFGCODE,
                    });
                }
                this.$store.dispatch("setmfgs_imgs", mfgs_only);
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

        main_cat_images() {
            const clApi = new CloudinaryApi;
            
            clApi.vlLatestProducts(GCONST.CL_METARTYPE_CATEGORY_ONLY).then(imgURL => {
                const cat1_imgs = [];

                if(imgURL){
                    imgURL.forEach(i => {
                        cat1_imgs.push({
                            'publicId' : i.publicId,
                            'mediaType' : i.mediaType,
                            'DXCD01' : i.metadata.DXCD01,
                            'MfgCode' : i.metadata.mcmfgc,
                            'MfgName' : i.metadata.mcname,
                        });
                    });

                    this.$store.dispatch("setcat_img_level_1", cat1_imgs);
                }
            });
        },

        wd_mfgs() {
            axiosvl.post(this.$store.getters['api/wd_mfgs_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {}
                }
            })
            .then((response) => {
                const MFGSX = response.data.webroutine.lists.MFGSX;
                const wd_mfgxs = [];
                for (const key in MFGSX.entries) {
                    const obj = MFGSX.entries[key];
                    wd_mfgxs.push({
                        MFG_CODE: obj.MCMFGCX,
                        MFG_DESC: obj.MCNAMEX,
                    });
                }
                this.$store.dispatch("setwd_mfgxs", wd_mfgxs);

                const MFGS = response.data.webroutine.lists.MFGS;
                const wd_mfgs = [];
                for (const key in MFGS.entries) {
                    const obj = MFGS.entries[key];
                    wd_mfgs.push({
                        MFG_CODE: obj.MCMFGC,
                        MFG_DESC: obj.MCNAME,
                        SEO: obj.MCNAME.replace(/ /g, "-"),
                    });
                }
                this.$store.dispatch("setwd_mfgs", wd_mfgs);
            })
            .catch((error) => {
                this.isloading = false;
                console.log("error - " + error);
            });
        },

        catalogs(CATPN) {
            axiosvl.post(this.$store.getters['api/catalog_list_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "EHCUST": {"value": this.$store.getters.customer}
                }
            })
            .then((response) => {
                // console.log(response);
                const lists = response.data.webroutine.lists;
                const CATMNU = lists.CATMNU.entries;
                const catclass = CATMNU.find(catalog => catalog.CATDPN === CATPN);                
                if (catclass != undefined){
                    this.$store.dispatch('setStoreConfigID', catclass.CATDPN);
                    this.$store.dispatch('api/switchStore', {
                        'CATNAME' : catclass.CATNAME,
                        'CATCLASS' : catclass.CATCLASS
                    });
                }else{
                    this.$store.dispatch('setStoreConfigID', '');
                    this.$store.dispatch('api/switchStore', {
                        'CATNAME' : '',
                        'CATCLASS' : ''
                    });
                }

                this.$store.dispatch('appInitialiazed', {initialized : true});
            });
        },

        /**
         * fetch RMA enabled
         * 
         */
        fetchRMAEnabled() {
            axiosvl.post(this.$store.getters['api/return_enable_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "EHCUST": {"value": this.$store.getters.customer}
                }
            })
            .then((response) => {
                const fields  =  response.data.webroutine.fields;
                const ENABLED = fields.ENABLED.value;
                
                // store  the enabled  value in state
                this.$store.dispatch('setRMA_enabled', {
                    'ENABLED' : ENABLED
                }); 
            });
        },

        /** reset the values from the state */
        resetValues() {
            this.$store.dispatch('setCat_faceted_filter', null);
            this.$store.dispatch('setSolr_faceted_filter', null);
        }
    },

    created() {
        // Reset Vue State data whenever the application is loaded
        this.$store.state['system'].erppartition = 'ERP';
        this.$store.state['system'].partition = 'CML';
        this.$store.state['system'].language = 'ENG';

        this.$store.dispatch("message/resetStatus");
        this.$store.dispatch("resetCustomerDetails");

        this.initialize();
        
        this.wd_mfgs();
        
    }
}
</script>

<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;  
        color: #2c3e50;
    }
    #nav {
        padding: 30px;
    }
    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }
    #nav a.router-link-exact-active {
        color: #42b983;
    }
    .fade-button-enter-from,
    .fade-button-leave-to {
        opacity: 0;
    }
    .fade-button-enter-active {
        transition: opacity 0.3s ease-out;
    }
    .fade-button-leave-active {
        transition: opacity 0.3s ease-in;
    }
    .fade-button-enter-to,
    .fade-button-leave-from {
        opacity: 1;
    }
</style>